import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-switch-dialog',
  templateUrl: './confirm-switch-dialog.component.html',
  styleUrls: ['./confirm-switch-dialog.component.css']
})
export class ConfirmSwitchDialogComponent {

  constructor(public dialogRef: MatDialogRef<ConfirmSwitchDialogComponent>) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
